import { useSelector } from "react-redux"
import { selectWaterMark } from "../../app/user/userSlice"
/*
https://blog.csdn.net/qq_43649479/article/details/112743573
https://www.zhangxinxu.com/sp/svg-text.php
*/
export default function WaterMark({ children }) {
    const watermark = useSelector(selectWaterMark)
    const text = watermark ? watermark : '鸿雁荟'
    const styles = {
        background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='260' height='130' style='transform:rotate(-15deg)'%3E%3Ctext x='40%25' y='40%25' font-size='18' fill='%237b8598' font-family='system-ui, sans-serif' text-anchor='middle' dominant-baseline='middle'%3E${text}%3C/text%3E%3C/svg%3E")`
    }
    return (
        <div style={styles}>
            {children}
        </div>
    )
}